import React from 'react';
import { Link } from 'react-router-dom';
import styles from './style.module.css';
import * as Routes from '../../../../constants/routes';
import { trackingEvent } from '../../../../helpers/tracking';
import AssessmentForm from '../../components/forms/assessment';
import InfoBox from '../../../../common/components/info-box';

const tracking = {
    eventAction: 'Budget Calculator - Assessment',
    eventLabel: 'Your Assessment'
};

const ctaButton = {
    link: `${process.env.PUBLIC_URL}/budget-planner${Routes.CONTACTEMAIL}`,
    label: 'Email Results',
    onClick: () => trackingEvent(tracking)
};

const printButton = {
    // eslint-disable-next-line
    link: 'javascript:window.print()',
    label: 'Print Results',
};

const tooltipButton = {
    link: `${process.env.PUBLIC_URL}/budget-planner${Routes.CONTACTCOACH}`,
    label: 'Connect with a Coach',
    onClick: () => trackingEvent(tracking)
};

const tooltip = {
    title: 'Looking for a professional opinion?',
    content: 'Connect with a Libro Coach to find out how we can help you build your own financial happiness.',
    button: tooltipButton
};

export default () => (
    <div className={styles.page}>
        <h1 className={styles.mainTitle}>Your Assessment</h1>
        <p className={styles.text}>Let's see how the numbers break down.</p>
        <div className={styles.buttonContainer}>
            <Link
                to={ctaButton.link}
                onClick={ctaButton.onClick}
                className={styles.ctaButton}
                title={ctaButton.label}
            >
                {ctaButton.label}
            </Link>
            <a
                href={printButton.link}
                className={styles.ctaButton}
                title={printButton.label}
            >
                {printButton.label}
            </a>
        </div>
        <AssessmentForm/>
        <InfoBox
            title={tooltip.title}
            content={tooltip.content}
            button={tooltip.button}
        />
    </div>
);
